import { render, staticRenderFns } from "./VirtualKeyboard.vue?vue&type=template&id=48d889dc&scoped=true&"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard.vue?vue&type=style&index=0&id=48d889dc&lang=scss&scoped=true&"
import style1 from "./VirtualKeyboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d889dc",
  null
  
)

export default component.exports